import React from "react";
var __jsx = React.createElement;
import stl from "@/pages/financing/financingMakeModel/FinancingMakeModel.module.css";
import { useCMS } from "@hooks/useCMS";
var BulletedList = function BulletedList(_ref) {
  var list = _ref.list;
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  return /*#__PURE__*/React.createElement("div", {
    key: list.title,
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("h3", {
    className: stl.listTitle
  }, list.title), /*#__PURE__*/React.createElement("ul", {
    className: stl.bulletedList
  }, list.list_items.split('\n').map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: stl.listItem
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl(list.icon),
      alt: list.icon.caption || "bullet",
      className: stl.bulletIcon,
      width: "24px",
      height: "24px"
    }), /*#__PURE__*/React.createElement("span", null, item));
  })));
};
export default BulletedList;